import React from 'react';
import vetPlaceholderImg from '../../assets/images/vet-profiles/vet-placeholder.png';
import { TooltipBouncer, TooltipBouncerProps } from '../../wag-react/components/floating-action-buttons';
export type AskAVetChatButtonProps = Partial<TooltipBouncerProps>;
export const AskAVetChatButton = ({
  avatar,
  tooltip,
  ...rest
}: AskAVetChatButtonProps) => <TooltipBouncer avatar={{
  src: vetPlaceholderImg,
  alt: 'Ask a vet',
  imageProps: {
    cursor: 'pointer'
  },
  cursor: 'pointer',
  ...avatar
}} tooltip={{
  text: 'Need pet insurance?',
  cursor: 'pointer',
  ...tooltip
}} display={['flex', 'none', null]} {...rest} data-sentry-element="TooltipBouncer" data-sentry-component="AskAVetChatButton" data-sentry-source-file="index.tsx" />;